var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";

import { Router } from "react-router-dom";
import { StaticRouter } from "react-router";
import { createBrowserHistory } from "history";

var UniversalRouter = function (_React$Component) {
  _inherits(UniversalRouter, _React$Component);

  function UniversalRouter(props) {
    _classCallCheck(this, UniversalRouter);

    var _this = _possibleConstructorReturn(this, (UniversalRouter.__proto__ || Object.getPrototypeOf(UniversalRouter)).call(this, props));

    _this.trackPageview = _this._trackPageview.bind(_this);

    if (typeof window !== "undefined") {
      _this.history = createBrowserHistory(props);
      _this.history.listen(_this.trackPageview);
    }
    return _this;
  }

  _createClass(UniversalRouter, [{
    key: "_trackPageview",
    value: function _trackPageview(location) {
      if (location.pathname != "/authorize" && window.ga) {
        window.ga("send", "pageview", { page: location.pathname + location.search });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof window === "undefined") {
        return React.createElement(StaticRouter, {
          location: this.props.path,
          context: this.props.context,
          children: this.props.children
        });
      } else {
        return React.createElement(Router, {
          children: this.props.children,
          history: this.history
        });
      }
    }
  }]);

  return UniversalRouter;
}(React.Component);

export default UniversalRouter;


UniversalRouter.propTypes = {
  children: PropTypes.node,
  path: PropTypes.string,
  context: PropTypes.object
};


// WEBPACK FOOTER //
// ./src/utils/UniversalRouter.js